<template>
<div class="chapter">
<div class="inner_page">
<div class="center">
<p class="structure" xml:lang="en-GB"><span class="bold"> </span></p>
<p class="glyphs"><span class="bold2"> </span></p>
<p class="glyphs"><span class="bold2"> </span></p>
<p class="body-text-center"><span class="bold4">Dedicated to the elders in my</span><span class="bold4"> </span><span class="bold4">tribe:</span></p>
<p class="body-text-center">Hilda &amp; Myron<br class="calibre2"/>Leota &amp; Gary<br class="calibre2"/>Joseph &amp; Mavis<br class="calibre2"/>and of course,<br class="calibre2"/>I would be nothing without my loves:<br class="calibre2"/>Torino, Golden, &amp; Sage</p>
<div class="calibre1" id="calibre_pb_3"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HappyHealthyYou_split_003.vue?70dc5e7c